import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, TypeOfReadingStepData } from '@packages/shared/core/quiz/entities';

type TypeOfReadingQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const TypeOfReadingQuizStep = ({ id, renderQuizScreen }: TypeOfReadingQuizStepProps) => {
  const logger = useLogger();
  const { next, stepData, back, updateUserPreferences } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { dataKey } = stepData as TypeOfReadingStepData;

  const onChosen = (data: { value: string; text: string }) => {
    updateUserPreferences(dataKey, data);
    next(data.text);
  };

  return (
    <>
      {renderQuizScreen({
        onChosen,
        goBack: back,
        ...(stepData as TypeOfReadingStepData),
      })}
    </>
  );
};

export default TypeOfReadingQuizStep;
